import React from "react";

// Neutrale, huisstijl-placeholder voor bedrijfsfoto's (SVG)
// variant: "card" | "detail"
export const ListingPlaceholder = ({ className = "", label = "Foto volgt" }) => {
  return (
    <div
      className={`relative w-full h-full flex items-center justify-center ${className}`}
      aria-hidden="true"
      style={{
        background:
          "linear-gradient(135deg, #173A5E 0%, #2E9CD6 55%, #6BC0E8 100%)",
      }}
    >
      {/* golf-decoratie */}
      <svg
        className="absolute inset-0 w-full h-full opacity-25"
        viewBox="0 0 400 300"
        preserveAspectRatio="none"
      >
        <path
          d="M0,180 C80,220 160,140 240,170 C320,200 360,210 400,170 L400,300 L0,300 Z"
          fill="#FFFFFF"
          opacity="0.3"
        />
        <path
          d="M0,210 C80,250 160,180 240,205 C320,230 360,240 400,210 L400,300 L0,300 Z"
          fill="#FFFFFF"
          opacity="0.4"
        />
      </svg>
      <div className="relative z-10 flex flex-col items-center gap-2">
        <div className="w-10 h-10 rounded-full bg-white/25 backdrop-blur flex items-center justify-center">
          <svg
            className="w-5 h-5 text-white"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="7" width="18" height="13" rx="2" />
            <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <circle cx="12" cy="13" r="3" />
          </svg>
        </div>
        <span className="text-white/90 text-xs font-[Poppins] font-semibold uppercase tracking-wider">
          {label}
        </span>
      </div>
    </div>
  );
};

export default ListingPlaceholder;
